import * as _4 from 'lodash4';
import { ICourseGrupInfo } from '../../components/smart_search/smart_catalog_search';
import { ApSmartSearchServant } from '../../servants/ap_smart_search_servant';
import { APSclOptionsItem } from './../../builders/ap_scl_options_item_builder';

const getSourceObject = (f: any) => {
  const withoutSourceOption = {};
  const withSourceOption = {
    $source: {
      uri: f.options
    }
  };
  const replaceOptions = _4.includes(['combobox', 'dropdown'], f.render_type) && _4.isString(f.options);
  return replaceOptions ? withSourceOption : withoutSourceOption;
};

const getGroupObject = (f: any) => {
  const withoutGroupOption = {};
  const withGroupOption = {
    $tag: f.group
  };
  return _4.isString(f.group) ? withGroupOption : withoutGroupOption;
};

export class SmartSearchPlugins {
  private courseGroupValue: string;
  private courseGroupInfo: ICourseGrupInfo;
  constructor(courseGroupInfo: ICourseGrupInfo) {
    this.courseGroupInfo = courseGroupInfo;
    this.courseGroupValue = courseGroupInfo.courseGroupValue;
  }

  private _addMapModifier(node: any, method: string) {
    node.$modifiers = node.$modifiers || [];
    node.$modifiers.push({
      kind: 'di/fn/map',
      attributes: {
        kind: 'object',
        host: 'user_space',
        method
      }
    });
    return node;
  }

  private _customKind(node: any, method: string) {
    node.kind = 'api';
    node.$is = 'definition';
    node = this._addMapModifier(node, method);
    return node;
  }

  private addLargeCourseGroupFields(fields: any = []) {
    const largeCourseGroupFieldType = [
      {
        group: null,
        initial_value: this.courseGroupValue,
        is_active: true,
        is_available: true,
        name: 'course_groups',
        render_type: 'hidden',
        required: false,
        readonly: true,
        title: 'Course Group'
      }
    ];
    const newFields = _4.unionBy(fields, largeCourseGroupFieldType, 'name');
    _4.find(newFields, { name: 'course_groups' }).initial_value = this.courseGroupValue;
    return newFields;
  }

  runMetadataFieldsPlugin() {
    document.body.dispatchEvent(
      new CustomEvent(`hil.transpiler.upgrade`, {
        detail: {
          value: {
            id: 'sgd_metadata_fields',
            visitEnter: {
              sgd_metadata_fields: (node: any) => {
                return this._customKind(node, 'mapFToHIL');
              }
            },
            hijack: {
              prePostCompile: (language: any) => {
                language.user_space = language.user_space || {};
                language.user_space.mapFToHIL = (o: any) => {
                  if (
                    ApSmartSearchServant.isLargeCourseGroupSmartSearch(this.courseGroupInfo) &&
                    !ApSmartSearchServant.isWildcardSmartSearch(this.courseGroupInfo)
                  ) {
                    o.fields = this.addLargeCourseGroupFields(o.fields);
                  }

                  const partialHIL: any = {
                    type: {
                      form_fields: {
                        properties: {}
                      }
                    },
                    tag: {}
                  };

                  partialHIL.type.form_fields.properties = _4.keyBy(
                    _4.map(o.fields || [], (f: any) => {
                      const optionEntry = window['$INJ']
                        .get('ngAPSclOptionsDatasource')
                        .values()
                        .find((optionDetails: APSclOptionsItem) => optionDetails.name === f.name);
                      if (optionEntry) {
                        f.options = optionEntry.options;
                        f.attributes = {
                          values: JSON.stringify([])
                        };
                      }
                      const sourceOptions = getSourceObject(f);
                      const groupTags = getGroupObject(f);
                      return {
                        ...f,
                        ...sourceOptions,
                        ...groupTags
                      };
                    }),
                    'name'
                  );
                  partialHIL.tag = _4.keyBy(
                    _4.map(o.groups || [], (f: any) => ({ ...f, render_type: 'accordion' })),
                    'nk'
                  );
                  return partialHIL;
                };
                return language;
              }
            }
          }
        }
      })
    );
  }
  runMetadataColumnsPlugin() {
    document.body.dispatchEvent(
      new CustomEvent(`hil.transpiler.upgrade`, {
        detail: {
          value: {
            id: 'sgd_metadata_columns',
            visitEnter: {
              sgd_metadata_columns: (node: any) => {
                return this._customKind(node, 'mapRToHIL');
              }
            },
            hijack: {
              prePostCompile: (language: any) => {
                language.user_space = language.user_space || {};
                language.user_space.mapRToHIL = (o: any) => {
                  const partialHIL: any = {
                    type: {
                      results: {
                        properties: {}
                      }
                    }
                  };

                  partialHIL.type.results.properties = _4.keyBy(o.columns, 'name');
                  partialHIL.type.results.properties = {
                    ...partialHIL.type.results.properties,
                    details_action: {
                      render_type: 'tasks',
                      title: 'Actions',
                      $region: 'details_region',
                      sortable: false,
                      order: 1000
                    },
                    add_to_term: {
                      render_type: 'tasks',
                      title: 'Plan actions',
                      hidden: ApSmartSearchServant.shouldHideAddToTermAction(this.courseGroupInfo),
                      $region: 'add_to_term_region',
                      sortable: false,
                      order: 1000
                    }
                  };
                  if (
                    ApSmartSearchServant.isPlanningFromTerm(this.courseGroupInfo) &&
                    !ApSmartSearchServant.isCoursegroupLocked(this.courseGroupInfo)
                  ) {
                    partialHIL.type.results.properties = {
                      ...partialHIL.type.results.properties,
                      plan_action: {
                        render_type: 'tasks',
                        title: 'Plan action',
                        $region: 'course_plan_region',
                        sortable: false,
                        order: 999
                      }
                    };
                  }
                  // Set Icons for co-req & pre-req

                  ['has_coreqs', 'has_prereqs'].forEach((key) => {
                    if (partialHIL.type.results.properties[key]) {
                      const iconType = _4.get(partialHIL.type.results.properties[key], 'icon', 'check');
                      partialHIL.type.results.properties[key] = {
                        ...partialHIL.type.results.properties[key],
                        hidden: ApSmartSearchServant.isLargeCourseGroupSmartSearch(this.courseGroupInfo),
                        render_type: 'template',
                        template: `<template><hi-if comparator='==' value-left='[[object.${key}]]' value-right='true'><hi-icon kind='${iconType}'></hi-icon></hi-if></template>`
                      };
                    }
                  });
                  return partialHIL;
                };
                return language;
              }
            }
          }
        }
      })
    );
  }
  runMultiFormPlugin() {
    document.body.dispatchEvent(
      new CustomEvent(`hil.transpiler.upgrade`, {
        detail: {
          value: {
            id: 'sgd_multi_form',
            visitEnter: {
              sgd_multi_form: (node: any) => {
                node = this._addMapModifier(node, 'convertArraysToString');
                return node;
              }
            },
            hijack: {
              prePostCompile: (language: any) => {
                language.user_space = language.user_space || {};
                language.user_space.convertArraysToString = (o: Record<string, any>) => {
                  for (const key in o) {
                    if (o[key] === '--NULL--' || o[key] === '') {
                      delete o[key];
                    }
                  }
                  return o;
                };
                return language;
              }
            }
          }
        }
      })
    );
  }

  runPlanToTermActionPlugin() {
    document.body.dispatchEvent(
      new CustomEvent(`hil.transpiler.upgrade`, {
        detail: {
          value: {
            id: 'plan_to_term_action',
            visitEnter: {
              plan_to_term_action: (node: any) => {
                node = this._addMapModifier(node, 'planToTermAction');
                return node;
              }
            },
            hijack: {
              prePostCompile: (language: any) => {
                const source = 'SMART_CATALOG';
                const closeSmartSearch = () => {
                  window['$INJ'].get('ngComponentCommunicatorService').publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
                  window['$INJ'].get('setSelectedPlannerResourceTabCommand')('MAP');
                };

                language.user_space = language.user_space || {};
                language.user_space.planToTermAction = (o: Record<string, any>) => {
                  if (ApSmartSearchServant.isInSwapMode(this.courseGroupInfo)) {
                    const courseNk = o['nk'];
                    const { courseToRemove, courseToAdd, programSlotToAdd, termId } =
                      ApSmartSearchServant.getSwapCommandParams(this.courseGroupInfo);
                    window['$INJ'].get('ngAPNotificationDelegate').info({
                      content: `<div l-kind="hort" l-align="center" l-width-fixed><hi-indicator theme="white" size='small' class="mrm"></hi-indicator>Swapping a course</div>`,
                      name: 'swapping'
                    });
                    window['$INJ']
                      .get('removeCourseFromTermAndAddCourseCommand')(
                        courseToRemove,
                        courseToAdd,
                        programSlotToAdd,
                        termId,
                        termId,
                        courseNk,
                        source
                      )
                      .then((data: any) => {
                        window['$INJ'].get('ngAPNotificationDelegate').dismissAlertByName('swapping');
                        closeSmartSearch();
                      });
                  } else {
                    const courseNk = o['nk'];
                    const { programSlot, courseGroup, courseToPlan } = ApSmartSearchServant.getPlanCommandParams(
                      this.courseGroupInfo
                    );
                    window['$INJ'].get('ngAPNotificationDelegate').info({
                      content: `<div l-kind="hort" l-align="center" l-width-fixed><hi-indicator theme="white" size='small' class="mrm"></hi-indicator>Planning a course</div>`,
                      name: 'planning'
                    });
                    window['$INJ']
                      .get('removeCourseGroupFromTermAndAddCourseCommand')(
                        programSlot,
                        courseGroup,
                        courseToPlan,
                        courseNk,
                        source
                      )
                      .then((data: any) => {
                        window['$INJ'].get('ngAPNotificationDelegate').dismissAlertByName('planning');
                        closeSmartSearch();
                      });
                  }
                  return o;
                };
                return language;
              }
            }
          }
        }
      })
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/configuration/plugins/smart_search_plugins.ts